import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { GeneralService } from '../../Services/generalservice.service';
declare var $: any;
import { ElementRef, Renderer2 } from '@angular/core';
@Component({
  selector: 'app-postjobs',
  templateUrl: './postjobs.component.html',
  styleUrls: ['./postjobs.component.scss']
})
export class PostjobsComponent {
    @ViewChild('myModal2') modalTemplate: TemplateRef<any>;
    EnquiryAry: any = [];
    public form: FormGroup;
    HomeURL: any; value: any;
    deptList: any[] = [];
    Categorylist: any;
    arr: any;
    Citylist: any;
    JobTypelist: any;
    Languageslist: any;
    Skillslist: any;
    SalaryRangelist: any;
    Statelist: any;
    Districtlist: any;
    loginDet: any;
    loginDetails: any;
    arr2: any[];
    arr3: any;
    PID: any;
    selectedSkills: any;
    Experiencelist: any;
    Qualificationlist: any;
    //Rskills: any;
    newSkill: any;
    displayAddSkillPopup = false;
    public Rskills: any;
    constructor(private elementRef: ElementRef, private renderer: Renderer2, public generalService: GeneralService,
        private http: HttpClient, private fb: FormBuilder, public Rm: ReactiveFormsModule,
        public router: Router, public route: ActivatedRoute) {
        debugger
        this.PID = this.route.snapshot.paramMap.get("PID");
        this.loginDet = localStorage.getItem("LoginDetails");
        this.loginDetails = JSON.parse(this.loginDet)
        console.log('pid', this.PID)
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeURL = data.Webservice;

        });
        this.form = this.fb.group({
            Jobtitle: ['', Validators.required], // Set up form control for Categoryname with required validation
             RecruiterName: ['', Validators.required], // Set up form control for Categoryname with required validation
           // CompanyName: ['', Validators.required], // Set up form control for Categoryname with required validation
            CategoryName: ['', Validators.required], // Set up form control for Categoryname with required validation
            CityName: ['', Validators.required], // Set up form control for Categoryname with required validation
            RequiredPosition: ['', Validators.required], // Set up form control for Categoryname with required validation
            TypeName: ['', Validators.required], // Set up form control for Categoryname with required validation
            Languages: ['', Validators.required], // Set up form control for Categoryname with required validation
            SalaryRange: ['', Validators.required], // Set up form control for Categoryname with required validation
            Skills: [this.selectedSkills], // Set up form control for Categoryname with required validation
            Experience: ['', Validators.required], // Set up form control for Categoryname with required validation
            Qualification: ['', Validators.required], // Set up form control for Categoryname with required validation
            JobDescription: ['', Validators.required] // Set up form control for Categoryname with required validation
        });


    }
    ngOnInit() {
        this.GetCategory();
        this.GetCity();
        this.GetJobType();
        this.GetLanguages();
        this.GetSalaryRange();
        this.GetSkills();
        this.GetExperience();
        this.GetQualification();

    }

    GetCategory() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_Category";
        this.generalService.GetData(url).then(data => {

            this.Categorylist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Categorylist.length; i++) {
                let type = this.Categorylist[i];
                if (type.CategoryName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }



    GetJobType() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_JobTypes";
        this.generalService.GetData(url).then(data => {

            this.JobTypelist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont2(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.JobTypelist.length; i++) {
                let type = this.JobTypelist[i];
                if (type.TypeName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    GetLanguages() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_Languages";
        this.generalService.GetData(url).then(data => {

            this.Languageslist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont3(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Languageslist.length; i++) {
                let type = this.Languageslist[i];
                if (type.Languages.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    GetSkills() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_Skills";
        this.generalService.GetData(url).then(data => {

            this.Skillslist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont4(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Skillslist.length; i++) {
                let type = this.Skillslist[i];
                if (type.Skills.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    GetSalaryRange() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_SalaryRange";
        this.generalService.GetData(url).then(data => {

            this.SalaryRangelist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont5(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.SalaryRangelist.length; i++) {
                let type = this.SalaryRangelist[i];
                if (type.SalaryRange.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }


    GetCity() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_City";
        this.generalService.GetData(url).then(data => {

            this.Citylist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont1(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Citylist.length; i++) {
                let type = this.Citylist[i];
                if (type.CityName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    GetExperience() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_Experience_Master";
        this.generalService.GetData(url).then(data => {

            this.Experiencelist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont6(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Experiencelist.length; i++) {
                let type = this.Experiencelist[i];
                if (type.Experience.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    GetQualification() {

        this.arr = [];
        this.arr.push({});

        var url = "api/Njobs/Get_Qualification";
        this.generalService.GetData(url).then(data => {

            this.Qualificationlist = data;
        }, err => {
            this.generalService.ShowAlert('ERROR', 'Something went wrong', 'error');
        });
    }

    searchCont7(event) {

        let filtered: any = [];
        let query = event.query;
        {
            this.deptList = [];
            for (let i = 0; i < this.Qualificationlist.length; i++) {
                let type = this.Qualificationlist[i];
                if (type.Qualification.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(type);
                    //   this.ButtonText = 'Add';
                }
            }
            this.deptList = filtered;
        }
    }

    //removeSkill(skillToRemove: any) {
    //    const currentSkills = this.form.get('Skills').value as any[];
    //    if (currentSkills) {
    //        const updatedSkills = currentSkills.filter(skill => skill.Skills !== skillToRemove.Skills);
    //        this.form.get('Skills').setValue(updatedSkills);
    //    }
    //}

    open() {
        debugger
        const modal3 = this.elementRef.nativeElement.querySelector('#myModal2');
        this.renderer.setStyle(modal3, 'display', 'block');  // Show the modal
    }

    onSubmit(val) {
        debugger

        if (this.loginDetails[0].ApprovalStatus === '1') {
            this.generalService.ShowAlert("ERROR", 'You do not have permission. admin to to accept your profile,please contact admin.', 'error');
            return;
        }
        this.arr = [];
        const selectedSkills = val.Skills.map(skill => skill.Skills).join(', ');
        this.arr.push({
            CompanyName: this.loginDetails[0].CompanyName,
            RecruiterName: val.RecruiterName,
            RID: this.loginDetails[0].RID,
            WorkingDomains: val.Jobtitle,
            RequiredPosition: val.RequiredPosition,
            RequiredSkills: selectedSkills,
            CID: val.CategoryName.CID,
            JTID: val.TypeName.JTID,
            LID: val.Languages.LID,
            SID: val.SalaryRange.SID,
            CityId: val.CityName.CityId,
            EXPID: val.Experience.EXPID,
            QID: val.Qualification.QID,
            JobDescription: val.JobDescription
        });
        const UploadFile = new FormData();
        UploadFile.append("Param", JSON.stringify(this.arr));
        UploadFile.append("Flag", '1');

        const url = "api/Njobs/NJ_PostJobs_Crud";
        this.generalService.PostData(url, UploadFile).then(data => {
            if (data === 'SUCCESS') {
                this.generalService.ShowAlert("SUCCESS", 'Your JobPost Completed Successfully', 'success');
                this.router.navigate(['/Managejobs']);
                //window.location.reload();
            } else {
                this.generalService.ShowAlert("ERROR", 'Something went wrong', 'error');
            }
        });
    }

    // Adds the new skill to the skills list
    addSkill(val: any): void {
        // Check if the skill is a non-empty string
        if (!val || val.trim() === '') {
            this.generalService.ShowAlert("WARNING", 'Skill name cannot be empty', 'warning');
            return;
        }

        // Check if the skill already exists in the local list
        const skillExists = this.Skillslist.some(skill => skill.Skills.toLowerCase() === val.toLowerCase());
        if (skillExists) {
            this.generalService.ShowAlert("WARNING", 'This skill already exists', 'warning');
            this.renderer.setStyle(this.elementRef.nativeElement.querySelector('#myModal2'), 'display', 'none');
            this.Rskills = ''; // Clear the input field
            return;
        }

        this.arr3 = [];
        this.arr3.push({
            Skills: val,
            CreatedBy: this.loginDetails[0].RID
        });

        var uploadfile = new FormData();
        uploadfile.append("Param", JSON.stringify(this.arr3));
        uploadfile.append("Flag", '1');
        var url = "api/Njobs/SkillMaster_Crud";

        this.generalService.PostData(url, uploadfile).then(data => {
            if (data && (data as string).toLowerCase() === 'success') {
                this.generalService.ShowAlert("SUCCESS", 'Your skills added successfully', 'success');

                const newSkillObject = { Skills: val };

                // Step 1: Add the new skill to the main options list
                this.Skillslist.push(newSkillObject);

                // Step 2: Add the new skill to the selected skills list to show as a chip
                const currentSelectedSkills = this.form.get('Skills').value || [];
                const updatedSelectedSkills = [...currentSelectedSkills, newSkillObject];
                this.form.get('Skills').setValue(updatedSelectedSkills);

                // Reset the modal input field
                this.Rskills = '';

                // Close the modal without a full page reload
                const modal3 = this.elementRef.nativeElement.querySelector('#myModal2');
                this.renderer.setStyle(modal3, 'display', 'none');

            } else {
                this.generalService.ShowAlert("ERROR", 'Something went wrong', 'error');
            }
        }).catch(error => {
            console.error('API Error:', error);
            this.generalService.ShowAlert("ERROR", 'API call failed. Please try again.', 'error');
        });
    }

    // In your CompanyAccountComponent class
    removeSkill(skillToRemove: any) {
        const currentSkills = this.form.get('Skills').value as any[];
        if (currentSkills) {
            const updatedSkills = currentSkills.filter(skill => skill.Skills !== skillToRemove.Skills);
            this.form.get('Skills').setValue(updatedSkills);
        }
    }

    //open() {
    //    debugger
    //    const modal3 = this.elementRef.nativeElement.querySelector('#myModal2');
    //    this.renderer.setStyle(modal3, 'display', 'block');  // Show the modal
    //}

    Close() {
        const modal3 = this.elementRef.nativeElement.querySelector('#myModal2');
        this.renderer.setStyle(modal3, 'display', 'none');  // Hide the modal
    }
}
